// eslint-disable-next-line
export default (props: any) => {
  return <main className="main__content_wrapper">{props.children}</main>;
};
